import React from 'react';
import {Link} from "react-router-dom";
import {ReactComponent as LeftIco} from "../../../images/icons/arrow-left.svg";

interface Props {
    title: string;
    link: string;
}

const NavbarBack = ({title, link}: Props) => {
    return (
        <Link className="btn btn-back btn-flex navbar-back-btn" to={link}>
            <LeftIco/>
            <h5 className="mb-0">
                {title}
            </h5>
        </Link>
    )
}

export default NavbarBack;